import React from 'react';

const styles = {
    base: {
        width: '100%',
        display: 'flex',
        flexFlow: 'row wrap',
        fontFamily: 'Hind, sans-serif',
        fontWeight: 100,
        color: '#303133',
        boxSizing: 'border-box'
    }
};

const PostMargins = ({style, ...props}) => {
    const bp = polyphony.hooks.useBreakpoint();
    const {post_margins,
           post_margins_mobile,
           post_max_width,
           paragraph_spacing,
           font_size,
           font_size_mobile} = polyphony.useState(s => s.measurements);

    const isMobile = bp === 'mobile';

    let pcPostStyle = `.PostMargins p:not(:last-of-type) { margin-bottom: ${paragraph_spacing} !important;}`;
    let jsStyle = {
        ...styles.base,
        fontSize: !isMobile ? font_size : font_size_mobile,
        padding: !isMobile ? post_margins : post_margins_mobile,
        maxWidth: post_max_width,
        ...style};
    return <>
        <style>{pcPostStyle}</style>
        <div {...props} className="PostMargins" style={jsStyle} />
    </>;
};

export default PostMargins;

